import "./ErrorMessage.css";
import React from "react";

export const ErrorMessage = ({ message }) => {
  return (
    <div className="message-container">
      <div className="message App-text-small">{message}</div>
    </div>
  );
};
